import constants from '@/app-configs/constants'

export default [
  {
    path: '/partner/list',
    name: 'partner-list',
    component: () => import('@/views/partner/partner-list/PartnerList.vue'),
    meta: {
      pageTitle: 'DEBTIA_PARTNER',
      breadcrumb: [
        {
          text: 'DEBTIA_PARTNER',
          active: true,
        },
      ],
      action: constants.action.permissionPartnerView,
      resource: constants.resource.partner,
      companyOnly: true,
    },
  },
  {
    path: '/users/view/:id',
    name: 'users-view',
    component: () => import('@/views/user/users-view/UsersView.vue'),
    meta: {
      action: constants.action.permissionPartnerView,
      resource: constants.resource.partner,
      companyOnly: true,
    },
  },
  {
    path: '/partner/edit/:id',
    name: 'partner-edit',
    component: () => import('@/views/partner/partner-edit/PartnerEditAccount.vue'),
    meta: {
      action: constants.action.permissionPartnerEdit,
      resource: constants.resource.partner,
      companyOnly: true,
    },
  },
  {
    path: '/partner/add',
    name: 'partner-add',
    component: () => import('@/views/partner/partner-add/PartnerAdd.vue'),
    meta: {
      title: 'add users',
      action: constants.action.permissionPartnerAdd,
      resource: constants.resource.partner,
      companyOnly: true,
    },
  },
]
